"use client";

import { useState, useRef, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import MobileHeader from "./MobileHeader";
import Icons from "../../../public/icons/HeaderIcons";
import { usePathname } from "next/navigation";
import "bootstrap/dist/css/bootstrap.css";

const VERIFY1 = [
  {
    path: "/checks/employment-education-checks",
    key: "Employment & Education Checks",
    label: "Employment & Education Checks",
    icon: "Education-Checks-header",
  },
  {
    path: "/checks/criminal-database",
    key: "Criminal & Database Checks",
    label: "Criminal & Database Checks",
    icon: "Criminal-Database-Checks-header",
  },
  {
    path: "/checks/Identity-address-checks",
    key: "Identity & Address Checks",
    label: "Identity & Address Checks",
    icon: "Identity-Address-Checks-header",
  },
  {
    path: "/checks/media-checks",
    key: "Media Checks",
    label: "Media Checks",
    icon: "Media-Checks-header",
  },
];

const VERIFY2 = [
  {
    path: "/checks/health-checks",
    key: "Health Checks",
    label: "Health Checks",
    icon: "Health-Checks-header",
  },
  {
    path: "/checks/other-checks",
    key: "Other Checks",
    label: "Other Checks",
    icon: "Other-Checks-header",
  },
  {
    path: "/checks/credit-checks",
    key: "Credit Check",
    label: "Credit Check",
    icon: "Credit-Check-header",
  },
  {
    path: "/checks/due-diligence",
    key: "Due Diligence",
    label: "Due Diligence",
    icon: "Due-Diligence-header",
  },
];

const FEATURES = [
  {
    path: "/solutions/staff-management",
    key: "Staff management",
    label: "Staff management",
    subtitle: "Streamline employee oversight",
    icon: "staff-management2",
  },
  {
    path: "/solutions/vendor-management",
    key: "Vendor management",
    label: "Vendor management",
    subtitle: "Ensure trusted partnerships",
    icon: "vendor-management2",
  },
  {
    path: "/solutions/task-management",
    key: "Task management",
    label: "Task management",
    subtitle: "Simplify workflow tracking",
    icon: "team-management2",
  },
  {
    path: "/solutions/manage-insufficiency",
    key: "Manage Insufficiency",
    label: "Manage Insufficiency",
    subtitle: "Address gaps efficiently",
    icon: "Manage-Insufficiency-header2",
  },
];
const IdentityCheck = [
  {
    path: "/apis/driving-license-verification",
    key: "Driving License",
    label: "Driving License Verification",
    subtitle: "Validate DL of users while onboarding",
    // image: "/images/Driving License Verification.svg",
    icon: "Driving-License-Verification",
  },
  {
    path: "/apis/aadhaar-verification",
    key: "Aadhaar Api",
    label: "Aadhaar Verification",
    subtitle: "OTP based Aadhar KYC",
    // image: "/images/Aadhar Verification.svg",
    icon: "Aadhaar-Verification",
  },
  {
    path: "/apis/passport-verification",
    key: "Digi Locker",
    label: "Passport Verification",
    subtitle: (<>Verify passport information while <br />onboarding</>),
    // image: "/images/Passport Verification.svg",
    icon: "Passport-Verification",
  },
  {
    path: "/apis/voterID-verification",
    key: "Voter",
    label: "Voter ID Verification",
    subtitle: (<>Verify Voter ID details while <br />onboarding</>),
    // image: "/images/Voter ID Verification.svg",
    icon: "Voter-ID-Verification",
  },
  {
    path: "/apis/facematch-kyc-digilocker",
    key: "Facematch DigiLocker",
    label: "Facematch + KYC via DigiLocker",
    subtitle: "AI facial match with DigiLocker KYC",
    icon: "Aadhaar-Verification",
  },
  {
    path: "/apis/education-check-digilocker",
    key: "Education DigiLocker",
    label: "Education Check via DigiLocker",
    subtitle: "Verify degrees from DigiLocker",
    icon: "Aadhaar-Verification",
  },
]

const EmploymentCheck = [
  {
    path: "/apis/bank-account-verification",
    key: "Bank Account",
    label: "Bank Account Verification",
    image: "/images/bankLogo.webp",
  },
  {
    path: "/apis/driving-license-verification",
    key: "Driving License",
    label: "Professional Reference",
    image: "/images/livenessLogo.webp",
  },
  {
    path: "/employment-history-verification-api",
    key: "Employment History",
    label: "Employment History",
    image: "/images/epfoLogo.webp",
  },
  {
    path: "/apis/aadhaar-verification",
    key: "Aadhar Api",
    label: "Credit Check",
    image: "/images/Aadhar Card.png"
  },

]

const SOLUTIONS1 = [
  {
    path: "/solutions/white-collar",
    key: "White Collar Verification",
    label: "White Collar Verification",
    subtitle: "Verify professionals securely",
    icon: "White-Collar-Verification",
  },
  {
    path: "/solutions/blue-collar",
    key: "Blue Collar Verification",
    label: "Blue Collar Verification",
    subtitle: "Validate skilled workers",
    icon: "Blue-Collar-Verification",
  },
  {
    path: "/solutions/leadership",
    key: "Leadership Verification",
    label: "Leadership Verification",
    subtitle: "Assess leadership credentials",
    icon: "Leadership-Verification",
  },
  {
    path: "/solutions/gig-worker",
    key: "Gig Worker Verification",
    label: "Gig Worker Verification",
    subtitle: "Authenticate flexible workforce",
    icon: "Gig-Worker-Verification",
  },

  // {
  //   path: "/screening/moonlighting",
  //   key: "Moonlighting",
  //   label: "Moonlighting",
  //   icon: "Moonlighting",
  // },
];

const NEW_SOLUTIONS = [
  {
    path: "/solutions/hr-teams",
    key: "HR Teams",
    label: "For HR Teams",
    subtitle: "Empower your HR department",
    icon: "staff-management2",
  },
  {
    path: "/solutions/staffing-agencies",
    key: "Staffing Agencies",
    label: "Staffing Agencies",
    subtitle: "High-volume scalability",
    icon: "team-management2",
  },
  {
    path: "/solutions/enterprises",
    key: "Enterprises",
    label: "For Enterprises",
    subtitle: "Enterprise-grade checks",
    icon: "vendor-management2",
  },
];

const OTHERS = [
  {
    path: "/solutions/digital-address-verification",
    key: "Digital Address Verification",
    label: "Digital Address Verification",
    subtitle: "Digitally Verify the Address",
    icon: "Digital-Address-Verification",
  },
  {
    path: "/solutions/advanced-verification-technology",
    key: "Advanced Verification Technology",
    label: "Advanced Verification Technology",
    subtitle: "Advanced Verification Technology",
    icon: "Advanced-Verification-Technology",
  },
  {
    path: "/solutions/end-to-end-encryption",
    key: "End-to-End Encryption",
    label: "End-to-End Encryption",
    subtitle: "End-to-End Encryption",
    icon: "End-to-End Encryption",
  },
  {
    path: "/solutions/payment-invoicing-integration",
    key: "Streamlined Payment Invoicing Integration",
    label: "Payment Invoicing Integration",
    subtitle: "Streamlined Payment Invoicing Integration",
    icon: "Payment-Invoicing-Integration",
  },
  {
    path: "/solutions/employee-background-verification-and-screening-software",
    key: "Employee Background Verification & Screening Software",
    label: "Employee Background Verification",
    subtitle: "Employee Background Verification",
    icon: "End-to-End Encryption",
  },
  // {
  //   path: "/solutions/residence-verification",
  //   key: "Residence Verification",
  //   label: "Residence Verification",
  //   subtitle: "Residence Verification",
  //   icon: "Digital-Address-Verification",
  // },
];

const USE_CASES = [
  {
    path: "/use-cases/employee-onboarding-verification",
    key: "Employee Onboarding Verification",
    label: "Employee Onboarding Verification",
    subtitle: "Streamline employee onboarding",
    icon: "staff-management2",
  },
  {
    path: "/use-cases/vendor-onboarding-verification",
    key: "Vendor Onboarding Verification",
    label: "Vendor Onboarding Verification",
    subtitle: "Secure vendor verification",
    icon: "vendor-management2",
  },
  {
    path: "/use-cases/customer-onboarding-verification",
    key: "Customer Onboarding Verification",
    label: "Customer Onboarding Verification",
    subtitle: "Fast customer KYCs",
    icon: "team-management2",
  },
  {
    path: "/use-cases/remote-hiring-verification",
    key: "Remote Hiring",
    label: "Remote Hiring",
    subtitle: "Safely hire remote talent globally",
    icon: "team-management2",
  },
  {
    path: "/use-cases/api-based-verification",
    key: "API Based Verification",
    label: "API Based Verification",
    subtitle: "Automated API solutions",
    icon: "VerifyAPI",
  },
  {
    path: "/use-cases/fraud-prevention",
    key: "Fraud Prevention",
    label: "Fraud Prevention",
    subtitle: "Prevent identity fraud",
    icon: "Identity-Address-Checks-header",
  },
  {
    path: "/use-cases/digital-kyc-loan-companies",
    key: "Digital KYC For Loan Companies",
    label: "Digital KYC For Loan Companies",
    subtitle: "KYC for loan disbursement",
    icon: "Credit-Check-header",
  },
];

const OTHERS2 = [
  // {
  //   path: "/solutions/video-kyc",
  //   key: "Video KYC",
  //   label: "Video KYC",
  //   subtitle: "Video KYC",
  //   icon: "Video-KYC",
  // },
  {
    path: "/solutions/hrms-integration",
    key: "HRMS Integration",
    label: "HRMS Integration",
    subtitle: "Integration in you existing system",
    icon: "HRMS-Integration",
  },
  {
    path: "/solutions/FE-mobile-app",
    key: "Field Executive Mobile App",
    label: "Field Executive Mobile App",
    subtitle: "Field Executive Mobile App",
    icon: "HRMS-Integration",
  },
  {
    path: "/solutions/security-and-compliance",
    key: "Security And Compliance",
    label: "Security And Compliance",
    subtitle: "Security And Compliance",
    icon: "End-to-End Encryption",
  },
  {
    path: "/solutions/ai-background-verification",
    key: "AI Background Verification",
    label: "AI Background Verification",
    subtitle: "AI Background Verification",
    icon: "HRMS-Integration",
  },
  {
    path: "/solutions/employment-verification",
    key: "Employment Verification",
    label: "Employment Verification",
    subtitle: "Employment Verification",
    icon: "staff-management2",
  },

];
const CriminalChecks = [
  {
    path: "/solutions/gig-worker",
    key: "Gig Worker Verification",
    label: "Court Record",
    image: "/images/ccrvLogo.svg",
  },
  {
    path: "/solutions/drug-&-pre-employment-health",
    key: "Drug and Pre-Employment Health Checkups",
    label: "Police Verification",
    image: "/images/companyVerificationLogo.webp",
  },

];
const EducationChecks = [
  {
    path: "/solutions/gig-worker",
    key: "Gig Worker Verification",
    label: "Education Checks",
    image: "/images/bankLogo.webp",
  },


];
const HealthChecks = [
  {
    path: "/solutions/gig-worker",
    key: "Gig Worker Verification",
    label: "Drug Check",
    image: "/images/cowinLogo.webp",
  },


];
const Bussiness = [
  {
    path: "/apis/GSTIN-verification",
    key: "GSTIN Verification",
    label: "GSTIN Verification",
    subtitle: "Validate Business GST details",
    // image: "/images/GSTIN Verification2.svg",
    icon: "GSTIN-Verification",
  },
  {
    path: "/apis/company-verification",
    key: "Company Verification",
    label: "Company Verification",
    subtitle: (<>Verify company registration <br />details</>),
    // image: "/images/Company Verification.svg",
    icon: "Company-Verification",
  },
  {
    path: "/apis/bank-account-verification",
    key: "Bank Account Verification",
    label: "Bank Account Verification",
    subtitle: (<>Verify bank account details of <br />company or users</>),
    // image: "/images/Bank Account Verification2.svg",
    icon: "Bank-Account-Verification",
  },
  {
    path: "/apis/MSME-verification",
    key: "MSME Verification",
    label: "MSME Verification",
    subtitle: "MSME registered company verification",
    icon: "MSME-Verification",
  },
  {
    path: "/apis/corporate-cin",
    key: "Corporate CIN",
    label: "Corporate CIN",
    subtitle: "Verify Corporate Identification Number",
    icon: "Company-Verification",
  },
  {
    path: "/apis/gst-details-advance",
    key: "GST Details Advance",
    label: "GST Details Advance",
    subtitle: "Deep business intelligence & filing history",
    icon: "GSTIN-Verification",
  },
  {
    path: "/apis/pan-to-bank-accounts",
    key: "PAN to Bank Accounts",
    label: "PAN to Bank Accounts",
    subtitle: "Discover bank accounts linked to PAN",
    icon: "Bank-Account-Verification",
  },
  {
    path: "/apis/global-database-lseg",
    key: "Global Database LSEG",
    label: "Global Database (LSEG)",
    subtitle: "Sanctions, PEP & AML screening",
    icon: "Company-Verification",
  },
  {
    path: "/apis/salary-slip-bank-analyzer",
    key: "Salary Slip Analyzer",
    label: "Salary Slip Bank Analyzer",
    subtitle: "Verify salary vs bank statement",
    icon: "Bank-Account-Verification",
  },
];
const Assest = [
  {
    path: "/apis/FSSAI-verification",
    key: "USSAI License Verification",
    label: "FSSAI License Verification",
    subtitle: "Verify FSSAI License through our API",
    // image: "/images/FSSAI License Verification.svg",
    icon: "FSSAI-License-Verification",
  },
  {
    path: "/apis/vehicle-verification",
    key: "Vehicle RC Verification",
    label: "Vehicle RC Verification",
    subtitle: (<>Verify vehicle rc and owner <br />details through our API</>),
    // image: "/images/Vehicle RC Verification2.svg",
    icon: "Vehicle-RC-Verification",
  },
  {
    path: "/apis/uan-verification",
    key: "UAN Verification",
    label: "UAN Verification",
    subtitle: "UAN Verification",
    icon: "UAN-Verification",
  },
  {
    path: "/apis/court-record",
    key: "Court Record Verification",
    label: "Court Record Verification",
    subtitle: "Court Record Check",
    icon: "Court-Record-Verification",
  },
  {
    path: "/apis/credit-report-crif",
    key: "Credit Report CRIF",
    label: "Credit Report (CRIF)",
    subtitle: "CRIF High Mark bureau report",
    icon: "Credit-Check-header",
  },
  {
    path: "/apis/credit-report-experian",
    key: "Credit Report Experian",
    label: "Credit Report (EXPERIAN)",
    subtitle: "Experian India bureau report",
    icon: "Credit-Check-header",
  },
  {
    path: "/apis/pan-to-bank-accounts",
    key: "PAN to Bank Accounts",
    label: "PAN to Bank Accounts",
    subtitle: "Discover bank accounts via PAN",
    icon: "Bank-Account-Verification",
  },
  {
    path: "/apis/global-database-lseg",
    key: "Global Database LSEG",
    label: "Global Database (LSEG)",
    subtitle: "Sanctions, PEP & AML screening",
    icon: "Court-Record-Verification",
  },
  {
    path: "/apis/salary-slip-bank-analyzer",
    key: "Salary Slip Analyzer",
    label: "Salary Slip Bank Analyzer",
    subtitle: "Verify salary vs bank statement",
    icon: "Bank-Account-Verification",
  },

];
const helpcenter = [
  {
    path: "/help-center-for-BGV",
    key: "help center BGV",
    label: "For BGV",
    details: "24*7 support to resolve all our BGV queries",
    image: "/images/Voter ID.png",
  },
  {
    path: "/help-center-for-vendor",
    key: "help center vendor",
    label: "For Vendor",
    details: "24*7 support to resolve all our Vendor queries",
    image: "/images/Driving License.png",
  },
  {
    path: "/help-center-for-APIs",
    key: "help center Api",
    label: "For APIs",
    details: "24*7 support to resolve all API queries",
    icon: "vendor-management",
  },

];
const products = [
  {
    path: "/products/verifyx",
    key: "VerifyX",
    label: "VerifyX",
    // details:"24*7 support to resolve all our BGV queries",
    // image: "/images/VerifyX2.svg",
    icon: "VerifyX",
  },
  {
    path: "/apis",
    key: "VerifyAPI",
    label: "VerifyAPI",
    // details:"24*7 support to resolve all our Vendor queries",
    // image: "/images/API product2.svg",
    icon: "VerifyAPI",
  },
  // {
  //   path: "/elocker",
  //   key: "eLocker",
  //   label: "E-Locker",
  //   // details:"24*7 support to resolve all our Vendor queries",
  //   // image: "/images/API product2.svg",
  //   icon: "VerifyX",
  // },
  // {
  //   path: "/help-center-for-APIs",
  //   key: "Ally",
  //   label: "Ally",
  //   // details:"24*7 support to resolve all API queries",
  //   image: "/images/ally.svg",
  // },
  // {
  //   path: "/products/blockcertify",
  //   key: "Block Certify",
  //   label: "Block Certify",
  //   // details:"24*7 support to resolve all API queries",
  //   image: "/images/Block Certify.svg",
  // },
];
const IND_FINTECH = [
  { name: "NBFC Verification", slug: "nbfc-verification", icon: "Credit-Check-header", subtitle: "Streamline NBFC onboarding" },
  { name: "Banking Verification", slug: "banking-verification", icon: "Bank-Account-Verification", subtitle: "Identity solutions for banks" },
  { name: "Digital Lending Platforms", slug: "digital-lending-verification", icon: "Credit-Check-header", subtitle: "Borrower verification APIs" },
  { name: "Fintech Platforms", slug: "fintech-verification", icon: "GSTIN-Verification", subtitle: "Digital onboarding for Fintech" },
  { name: "Insurance Companies", slug: "insurance-verification", icon: "Due-Diligence-header", subtitle: "Fraud detection for insurance" },
  { name: "Payment Gateways", slug: "payment-gateway-verification", icon: "Bank-Account-Verification", subtitle: "Merchant KYC verification" },
].map(i => ({ path: `/industries/${i.slug}`, key: i.name, label: i.name, icon: i.icon, subtitle: i.subtitle }));

const IND_HR = [
  { name: "Enterprises", slug: "enterprise-verification", icon: "Identity-Address-Checks-header", subtitle: "Corporate verification" },
  { name: "Staffing Agencies", slug: "staffing-agencies-verification", icon: "team-management2", subtitle: "Bulk candidate screening" },
  { name: "Recruitment Agencies", slug: "recruitment-agency-verification", icon: "staff-management2", subtitle: "Faster hiring cycles" },
  { name: "HR Tech Platforms", slug: "hr-tech-verification", icon: "HRMS-Integration", subtitle: "Embedded verification APIs" },
  { name: "Freelance Platforms", slug: "freelance-platform-verification", icon: "Other-Checks-header", subtitle: "Gig worker trust & safety" },
  { name: "Domestic Help Services", slug: "domestic-help-verification", icon: "Education-Checks-header", subtitle: "Safe background checks" },
  { name: "Security Agencies", slug: "security-agency-verification", icon: "Identity-Address-Checks-header", subtitle: "Guard background verification" },
].map(i => ({ path: `/industries/${i.slug}`, key: i.name, label: i.name, icon: i.icon, subtitle: i.subtitle }));

const IND_LOGISTICS = [
  { name: "Logistics Companies", slug: "logistics-verification", icon: "Vehicle-RC-Verification", subtitle: "Driver & vehicle onboarding" },
  { name: "Fleet Management", slug: "fleet-verification", icon: "Vehicle-RC-Verification", subtitle: "Automated RC & DL checks" },
  { name: "Delivery Platforms", slug: "delivery-platform-verification", icon: "Digital-Address-Verification", subtitle: "Address verification India" },
  { name: "Ride-Sharing Apps", slug: "rideshare-verification", icon: "Identity-Address-Checks-header", subtitle: "Driver identity verification" },
].map(i => ({ path: `/industries/${i.slug}`, key: i.name, label: i.name, icon: i.icon, subtitle: i.subtitle }));

const IND_RETAIL = [
  { name: "E-commerce Platforms", slug: "ecommerce-verification", icon: "MSME-Verification", subtitle: "Seller verification for ecom" },
  { name: "Marketplace Platforms", slug: "marketplace-verification", icon: "Company-Verification", subtitle: "Vendor verification marketplace" },
  { name: "B2B Marketplaces", slug: "b2b-marketplace-verification", icon: "GSTIN-Verification", subtitle: "Business verification APIs" },
  { name: "Vendor Onboarding", slug: "vendor-onboarding-verification", icon: "UAN-Verification", subtitle: "Verified vendor onboarding" },
].map(i => ({ path: `/industries/${i.slug}`, key: i.name, label: i.name, icon: i.icon, subtitle: i.subtitle }));

const IND_OTHERS = [
  { name: "Hospitals", slug: "hospital-verification", icon: "Criminal-Database-Checks-header", subtitle: "Hospital staff verification" },
  { name: "Telemedicine Platforms", slug: "telemedicine-verification", icon: "Identity-Address-Checks-header", subtitle: "Doctor verification India" },
  { name: "Healthcare Staffing", slug: "healthcare-staffing-verification", icon: "Media-Checks-header", subtitle: "Nurse background verification" },
  { name: "EdTech Platforms", slug: "edtech-verification", icon: "Education-Checks-header", subtitle: "Student identity verification" },
  { name: "Universities & Colleges", slug: "education-verification", icon: "Education-Checks-header", subtitle: "Student KYC verification" },
  { name: "Real Estate", slug: "real-estate-verification", icon: "Identity-Address-Checks-header", subtitle: "Tenant verification India" },
  { name: "Rental Platforms", slug: "rental-platform-verification", icon: "Digital-Address-Verification", subtitle: "Tenant background checks" },
  { name: "Legal Firms", slug: "legal-verification", icon: "Due-Diligence-header", subtitle: "Client verification for legal" },
  { name: "Consulting Firms", slug: "consulting-verification", icon: "Education-Checks-header", subtitle: "Professional staff verification" },
  { name: "Government contractors", slug: "government-verification", icon: "Court-Record-Verification", subtitle: "Contractor verification India" },
].map(i => ({ path: `/industries/${i.slug}`, key: i.name, label: i.name, icon: i.icon, subtitle: i.subtitle }));
const more = [
  {
    path: "/partners",
    key: "Partners",
    label: "Partners",
    // details:"24*7 support to resolve all our BGV queries",
    image: "/images/partners2.svg",
  },
  {
    path: "/docs",
    key: "API documentation",
    label: "API documentation",
    // details:"24*7 support to resolve all our Vendor queries",
    image: "/images/documentation2.svg",
  },

];
export default function Header() {
  const [hover, setHovered] = useState(false);
  const [id, setId] = useState();
  const [visible, setVisible] = useState(false);
  const [drop, setDrop] = useState(false);
  const [ApiDrop, setDropApi] = useState(false);
  const [industriesDrop, setIndustriesDrop] = useState(false);
  const [useCasesDrop, setUseCasesDrop] = useState(false);
  const [helpCenterDrop, setHelpCenterDrop] = useState(false);
  const [hideLogo, setHideLogo] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);
  const pathname = usePathname() || "/";
  const [show, setShow] = useState("All");
  const solutionsRef = useRef(null);
  const apisRef = useRef(null);
  const industriesRef = useRef(null);
  const useCasesRef = useRef(null);
  const productsRef = useRef(null);
  const headerRef = useRef(null);

  const closeAllDropdowns = () => {
    setDrop(false);
    setDropApi(false);
    setIndustriesDrop(false);
    setUseCasesDrop(false);
    setHelpCenterDrop(false);
  };

  const handleClickOutside = (event) => {
    const isInside = (
      (solutionsRef.current && solutionsRef.current.contains(event.target)) ||
      (apisRef.current && apisRef.current.contains(event.target)) ||
      (industriesRef.current && industriesRef.current.contains(event.target)) ||
      (useCasesRef.current && useCasesRef.current.contains(event.target)) ||
      (productsRef.current && productsRef.current.contains(event.target))
    );

    if (!isInside) {
      closeAllDropdowns();
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    closeAllDropdowns();
  }, [pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);



  const renderDropdownItems = (items) =>
    items.map((item) => (
      <Link
        href={item.path}
        className={`flex items-start group hover:bg-[#f2f7fa] pl-2 pr-3 pt-[12px] pb-[9px] rounded-md ${item.label === "Passport Verification" ? "mt-[6px] mb-0 pb-0" : item.label === "Company Verification" ? "mb-0 pb-0" : item.label === "Vehicle RC Verification" ? "mb-0 pb-0" : item.label === "Bank Account Verification" ? "mb-0 pb-0" : item.label === "Voter ID Verification" ? "mb-2 pb-0" : item.label === "MSME Verification" ? "mb-2 pb-0" : ""}`}
        key={item.key}

      >
        {item?.image ? <Image src={item?.image} height={40} width={40} alt={item?.key} className={`pr-1  ${hover && id === item.key ? "trasition-scrw-header" : "transform rotate-0 transition duration-300"}`} /> : ""}
        {item?.icon ?
          <span
            // className={`${hover && id === item.key ? "trasition-scrw-header" : "transform rotate-0 transition duration-300"
            //   }`}
            className="cursor-pointer"
          >
            <Icons name={item?.icon} fill={hover && id === item.key ? "#168def" : ""} />
          </span>
          : ""}
        <div className='relative flex flex-col ml-2 bottom-1'>
          <span className={`relative g-m lg:text-[16px] text-[14px] ${hover && id === item.key ? "text-[#168def] underline decoration-[0.6px]" : "text-[#3a3d46]"} group-hover:top-[1px] group-hover:!text-[#168def] group-hover:!underline group-hover:!decoration-[0.6px]`} onMouseEnter={() => {
            setHovered(true);
            setId(item.key);
          }}
            onMouseLeave={() => {
              setHovered(false);
              setId(null);
            }}>
            {item.label}
          </span>
          <span className="g-m text-[11px] text-[#A6A6A6] leading-[14px] cursor-pointer">{item.subtitle}</span>
          {/* {item?.details ? <p className={`mb-0 ml-2 pt-1 text-[12px] leading-5 ${hover && id === item.key ? "!text-[#168def]" : "text-[#3a3d46]"} dropdown-options`}>
            {item?.details}
          </p> : <></>} */}
        </div>

      </Link>
    ));

  const renderDropdownItems2 = (items) =>
    items.map((item) => (
      <Link href={item.path}
        className="flex items-center pl-2 py-2 rounded-xl pr-16 hover:bg-[#F2F7FA]"
        key={item.key}
        onMouseEnter={() => {
          setHovered(true);
          setId(item.key);
        }}
        onMouseLeave={() => {
          setHovered(false);
          setId(null);
        }}
      >
        {item?.image ? <Image src={item?.image} height={40} width={40} alt={item?.key} className={`pr-1  ${hover && id === item.key ? "trasition-scrw-header" : "transform rotate-0 transition duration-300"}`} /> : ""}
        {item?.icon ?
          <span
          // className={`${hover && id === item.key ? "trasition-scrw-header" : "transform rotate-0 transition duration-300"
          //   }`}
          >
            <Icons name={item?.icon} fill={hover && id === item.key ? "#168def" : ""} />
          </span>
          : ""}
        <div className='flex flex-col'>
          <span className={`g-m mb-0 ml-2 lg:text-[16px] text-[14px]  ${hover && id === item.key ? "!text-[#168def] !underline !decoration-[0.6px]" : "text-[#3a3d46]"} `}>
            {item.label}
          </span>
          {item?.details ? <p className={`mb-0 ml-2 pt-1 text-[12px] leading-5 ${hover && id === item.key ? "!text-[#168def]" : "text-[#3a3d46]"} dropdown-options`}>
            {item?.details}
          </p> : <></>}
        </div>

      </Link>
    ));

  return (
    <>
      <div style={{ height: headerHeight }} />
      <header ref={headerRef} className={`lg:flex lg:items-center fixed top-0 z-[999] w-full transition-all duration-300 ${scrolled ? "bg-white/95 backdrop-blur-sm shadow-sm" : ""}`} onMouseLeave={closeAllDropdowns}>
        <div className="max-[1200px]:hidden block container-padding-x w-full ">
          <div className="flex items-center justify-between gap-4 xl:gap-8">
            <Link href="/" className="flex-shrink-0">
              <Image src="/images/new-logo.svg" alt="Coincircletrust Logo" width="180" height="80" className="py-[20px]" />
            </Link>
            <div className="flex justify-center items-center 2xl:gap-[45px] min-[1350px]:gap-[35px] min-[1200px]:gap-[20px] gap-[10px]">
              {/* Home */}
              <Link
                className={`relative-group relative group`}
                color="foreground"
                onMouseEnter={() => {
                  closeAllDropdowns();
                }}
                onClick={closeAllDropdowns}
                href="/"
              >
                <span className={`g-m hover:text-[#168def] ${pathname === "/" ? "text-[#168def]" : "text-[#3A3D46]"}`}>
                  Home
                </span>
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
              </Link>
              {/* Solutions */}
              <div className="dropdown" ref={solutionsRef}>
                <span
                  className="flex items-center relative-group relative group"
                  onMouseEnter={() => {
                    closeAllDropdowns();
                    setDrop(true);
                    setShow("Manage");
                  }}
                  onMouseLeave={() => {
                    // Handled by header onMouseLeave
                  }}
                >
                  <Link href='/solutions'>
                    <div className={`g-m pr-1 cursor-pointer ${drop ? "text-[#168def]" : "text-[#3A3D46]"}`}>Solutions</div>
                  </Link>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={drop ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {drop && (
                  <div
                    className="dc bg-[#FFFFFF] rounded-2xl left-[24vw] min-[1700px]:left-[25vw]"
                    onMouseEnter={() => setDrop(true)}
                    onMouseLeave={() => setDrop(false)}
                  >
                    <div className="flex flex-col w-full">
                    <div className='grid grid-cols-[1fr_auto_auto_auto] gap-x-6 px-[34px] pt-6 pb-2'>
                      <div className="">
                        <span className="text-[#878a91] g-sm relative right-[1px]">Management</span>
                        <div className='grid gap-y-[8px] mt-[13px]'>{renderDropdownItems(FEATURES)}</div>
                      </div>
                      <div className="">
                        <span className="text-[#878a91] g-sm relative right-[1px]">Use Cases</span>
                        <div className='grid gap-y-[8px] mt-[13px]'>{renderDropdownItems(NEW_SOLUTIONS)}</div>
                      </div>
                      <div className="">
                        <span className="text-[#878a91] g-sm relative right-[1px]">Others</span>
                        <div className='grid gap-y-[8px] mt-[13px]'>{renderDropdownItems(OTHERS)}</div>
                      </div>
                      <div className="pr-5">
                        <span className="text-[#878a91] g-sm relative right-[1px]"></span>
                        <div className='grid gap-y-[8px] mt-[36px]'>{renderDropdownItems(OTHERS2)}</div>
                      </div>
                    </div>
                    <div className="flex justify-center pb-6">
                      <Link
                        href="/solutions"
                        className="g-m text-[#168def] text-[13px] border border-[#168def] bg-[#EEF7FF] hover:bg-[#168def] hover:text-white rounded-md px-10 py-[8px] transition-colors duration-200 inline-block"
                      >
                        Explore All Solutions
                      </Link>
                    </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Verification Checks */}
              <div className="dropdown" ref={apisRef}>
                <span
                  className="flex items-center relative-group relative group"
                  onMouseEnter={() => {
                    closeAllDropdowns();
                    setDropApi(true);
                    setShow("All");
                  }}
                  onMouseLeave={() => {
                    // Handled by header onMouseLeave
                  }}
                >
                  <Link href="/apis">
                    <div className={`g-m pr-1 cursor-pointer ${ApiDrop ? "text-[#168def]" : "text-[#3A3D46]"}`}> APIs</div>
                  </Link>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={ApiDrop ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {ApiDrop && (
                  <div
                    className="dc bg-[#FFFFFF] rounded-2xl left-[19vw] min-[1800px]:left-[25vw] pr-7"
                    onMouseEnter={() => setDropApi(true)}
                    onMouseLeave={() => setDropApi(false)}
                  >
                    {/* <div className='grid grid-cols-3  w-full'>
                      <div className='col-span-1 bg-blue-50 '>
                        <p className={` py-3  mb-0 font-bold text-[#168def] text-[15px] lg:text-[16px] cursor-pointer container-padding-x ${show === "All" ? "bg-blue-100 " : ""}`} onClick={() => setShow("All")}>All</p>

                        <p className={` py-3  mb-0 font-bold text-[#168def] text-[15px] lg:text-[16px] cursor-pointer container-padding-x ${show === "Id" ? "bg-blue-100 " : ""}`} onClick={() => setShow("Id")}>Identity</p>
                        <p className={` py-3  mb-0 font-bold text-[#168def] text-[15px] lg:text-[16px] cursor-pointer container-padding-x ${show === "Business" ? "bg-blue-100 " : ""}`} onClick={() => setShow("Business")}>Business</p>
                        <p className={` py-3  mb-0 font-bold text-[#168def] text-[15px] lg:text-[16px] cursor-pointer container-padding-x ${show === "Assest" ? "bg-blue-100 " : ""}`} onClick={() => setShow("Assest")}>Assets</p>
                      </div>
                      <div className='col-span-2 pl-4 py-[15px]'>
                        {show === "Assest" || show === "All" ? <div className='grid grid-cols-2 '>{renderDropdownItems(Assest)}</div> : null}
                        {show === "Id" || show === "All" ? <div className='grid grid-cols-2'>{renderDropdownItems(IdentityCheck)}</div> : null}
                        {show === "Business" || show === "All" ? <div className='grid grid-cols-2'>{renderDropdownItems(Bussiness)}</div> : null}
                      </div>
                    </div> */}
                    <div className='grid grid-cols-3 max-[1150px]:grid-cols-2 gap-x-6 px-[34px] pt-6 pb-5'>
                      <div >
                        <span className="text-[#878a91] g-sm relative right-[1px]">Identity</span>
                        <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IdentityCheck)}</div>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[#878a91] g-sm relative right-[1px]">Business</span>
                        <div className='grid gap-y-[6px] mt-[13px] flex-1'>{renderDropdownItems(Bussiness)}</div>
                        <div className="mt-4">
                          <Link
                            href="/apis"
                            className="g-m text-[#168def] text-[13px] border border-[#168def] bg-[#EEF7FF] hover:bg-[#168def] hover:text-white rounded-md px-4 py-[6px] transition-colors duration-200 inline-block"
                          >
                            Explore All APIs
                          </Link>
                        </div>
                      </div>
                      <div >
                        <span className="text-[#878a91] g-sm relative right-[1px]">Assets</span>
                        <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(Assest)}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="dropdown " ref={productsRef}>
                <span
                  className="flex items-center relative-group relative group"
                  onMouseEnter={() => {
                    closeAllDropdowns();
                    setHelpCenterDrop(true)
                  }}
                  onMouseLeave={() => {
                    // Handled by header onMouseLeave
                  }}
                >
                  <div className={`g-m pr-1 cursor-pointer ${helpCenterDrop ? "text-[#168def]" : "text-[#3A3D46]"}`}>Products</div>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={helpCenterDrop ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {helpCenterDrop && (
                  <div
                    className="dc bg-[#FFFFFF] !rounded-xl left-[44vw]"
                    onMouseEnter={() => setHelpCenterDrop(true)}
                    onMouseLeave={() => setHelpCenterDrop(false)}
                  >
                    <div className='grid gap-y-1 py-2 pl-[10px] pr-[10px]'>{renderDropdownItems2(products)}</div>
                  </div>
                )}
              </div>
              {/* Industries */}
              <div className="dropdown " ref={industriesRef}>
                <span
                  className="flex items-center relative-group relative group"
                  onMouseEnter={() => {
                    closeAllDropdowns();
                    setIndustriesDrop(true);
                  }}
                  onMouseLeave={() => {
                    // Handled by header onMouseLeave
                  }}
                >
                  <div className={`g-m pr-1 cursor-pointer ${industriesDrop ? "text-[#168def]" : "text-[#3A3D46]"}`}>Industries</div>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={industriesDrop ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {industriesDrop && (
                  <div
                    className="dc bg-[#FFFFFF] rounded-2xl left-[15vw] min-[1700px]:left-[20vw]"
                    onMouseEnter={() => setIndustriesDrop(true)}
                    onMouseLeave={() => setIndustriesDrop(false)}
                  >
                    <div className="flex flex-col w-full">
                      <div className='grid grid-cols-5 gap-x-4 px-[34px] pt-6 pb-2 w-full'>
                        <div className="">
                          <span className="text-[#878a91] g-sm relative right-[1px]">Fintech & BFSI</span>
                          <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IND_FINTECH)}</div>
                        </div>
                        <div className="">
                          <span className="text-[#878a91] g-sm relative right-[1px]">HR & Workforce</span>
                          <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IND_HR)}</div>
                        </div>
                        <div className="">
                          <span className="text-[#878a91] g-sm relative right-[1px]">Logistics & Mobility</span>
                          <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IND_LOGISTICS)}</div>
                        </div>
                        <div className="">
                          <span className="text-[#878a91] g-sm relative right-[1px]">Retail & Vendor</span>
                          <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IND_RETAIL)}</div>
                        </div>
                        <div className="">
                          <span className="text-[#878a91] g-sm relative right-[1px]">Healthcare & Others</span>
                          <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(IND_OTHERS)}</div>
                        </div>
                      </div>
                      {/* <div className="flex justify-center pb-6">
                        <Link
                          href="/industries"
                          onClick={() => setIndustriesDrop(false)}
                          className="g-m text-[#168def] text-[13px] border border-[#168def] bg-[#EEF7FF] hover:bg-[#168def] hover:text-white rounded-md px-10 py-[8px] transition-colors duration-200 inline-block"
                        >
                          Explore All Industries
                        </Link>
                      </div> */}
                    </div>
                  </div>
                )}
              </div>
              {/* Use Cases */}
              <div className="dropdown" ref={useCasesRef}>
                <span
                  className="flex items-center relative-group relative group"
                  onMouseEnter={() => {
                    closeAllDropdowns();
                    setUseCasesDrop(true);
                  }}
                  onMouseLeave={() => {
                    // Handled by header onMouseLeave
                  }}
                >
                  <Link href="/use-cases/employee-onboarding-verification">
                    <div className={`g-m pr-1 cursor-pointer whitespace-nowrap ${useCasesDrop ? "text-[#168def]" : "text-[#3A3D46]"}`}>Use Cases</div>
                  </Link>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={useCasesDrop ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {useCasesDrop && (
                  <div
                    className="dc bg-[#FFFFFF] rounded-2xl left-[20vw] min-[1800px]:left-[25vw] pr-7"
                    onMouseLeave={() => setUseCasesDrop(false)}
                  >
                    <div className='grid grid-cols-2 gap-x-6 px-[34px] pt-6 pb-5'>
                      <div className="flex flex-col">
                        <span className="text-[#878a91] g-sm relative right-[1px]">Use Cases</span>
                        <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(USE_CASES.slice(0, 4))}</div>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-[#878a91] g-sm relative right-[1px]">&nbsp;</span>
                        <div className='grid gap-y-[6px] mt-[13px]'>{renderDropdownItems(USE_CASES.slice(4))}</div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <Link
                className={`relative-group relative group`}
                color="foreground"
                onMouseEnter={() => {
                  closeAllDropdowns();
                }}
                onClick={closeAllDropdowns}
                href="/partners"
              >
                <span className={`g-m hover:text-[#168def] ${pathname === "/partners" ? "text-[#168def]" : "text-[#3A3D46]"}`}>
                  Partners
                </span>
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
              </Link>
              <Link
                className={`relative-group relative group`}
                color="foreground"
                onMouseEnter={() => {
                  closeAllDropdowns();
                }}
                onClick={closeAllDropdowns}
                href="/blog"
              >
                <span className={`g-m hover:text-[#168def] ${pathname === "/blog" ? "text-[#168def]" : "text-[#3A3D46]"}`}>
                  Blog
                </span>
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
              </Link>
              {/* Pricing */}
              {/* <Link
                className={`relative-group relative group`}
                color="foreground"
                onMouseEnter={() => {
                  setDropApi(false);
                  setHelpCenterDrop(false)
                }}
                onMouseLeave={() => setHoveredPath(pathname)}
                onClick={() => setDrop(false)}
                href="/pricing"
              >
                <span className={`g-m hover:text-[#168def] ${pathname === "/pricing" ? "text-[#168def]" : "text-[#3A3D46]"}`}>
                  Pricing
                </span>
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
              </Link> */}
              {/* About us */}
              <Link
                className={`relative-group relative group`}
                color="foreground"
                onMouseEnter={() => {
                  closeAllDropdowns();
                }}
                onClick={closeAllDropdowns}
                href="/about-us"
              >
                <span className={`g-m hover:text-[#168def] whitespace-nowrap ${pathname === "/about-us" ? "text-[#168def]" : "text-[#3A3D46] "} `}>
                  About us
                </span>
                <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
              </Link>
              {/* Help center */}
              {/* <div className="dropdown ">
                <span
                  className="flex items-center relative-group relative group"
                  onClick={() => setHelpCenterDrop(!helpCenterDrop)}
                  onMouseEnter={() => {
                    setEnter(true);
                    setDrop(false);
                    setDropApi(false);
                    setHelpCenterDrop(true)
                  }}
                  onMouseLeave={() => {
                    setEnter(false);
                    // setHelpCenterDrop(false)
                    // setDropApi(false)
                  }}
                  ref={dropdownRef}
                >
                    <button className={`g-m pr-1 font-semibold ${helpCenterDrop ? "text-[#168def]" : "text-[#3A3D46]"}`}> Help Center</button>
                  <div className="pt-[2px]">
                    <svg width="12" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.999999 1L7 7L13 1"
                        stroke={helpCenterDrop  ? "#168def" : "#3A3D46"}
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-0 h-[5px] rounded-t-md bg-blue-400 transition-all duration-300 origin-center origin-x-center group-hover:w-[100%]"></span>
                </span>
                {helpCenterDrop && (
                  <div
                    className="HelpCenterdropdown-content bg-[#FFFFFF] bg-opacity-[90%]"
                    onMouseEnter={() => setHelpCenterDrop(true)}
                    onMouseLeave={() => setHelpCenterDrop(false)}
                  >
                   <div className=''>{renderDropdownItems(helpcenter)}</div> 
                  </div>
                )}
              </div> */}
            </div>
            <Link href="/contact" className="flex-shrink-0 flex items-center justify-center !text-[#168DEF] hover:!text-white lg:text-[14px] text-[10px] border-[#168DEF] border-1 hover:border-0 rounded-full py-[10px] px-[20px] whitespace-nowrap cursor-pointer hover:bg-[#168DEF] transition-colors duration-300 hover:shadow-[#168DEF4D] hover:shadow-sm ">
              Talk to Sales
            </Link>
          </div>
        </div>
        <div className="max-[1200px]:block hidden w-full">
          <MobileHeader setHideLogo={setHideLogo} hideLogo={hideLogo} suppressHydrationWarning />
        </div>
      </header>
    </>
  );
}
